// extracted by mini-css-extract-plugin
export default {"MenuOption":"📚19-10-2x0t7Q","Check":"📚19-10-2_gou0","Icon":"📚19-10-2c5cPm"};